/**
 * Client-side password strength validator — same rules as backend/auth.py.
 * Returns an array of failing rule labels (empty if password passes).
 */
export function passwordStrengthErrors(password) {
  const errs = [];
  if (!password || password.length < 8) errs.push("At least 8 characters");
  if (!/[A-Z]/.test(password || "")) errs.push("One uppercase letter (A-Z)");
  if (!/[a-z]/.test(password || "")) errs.push("One lowercase letter (a-z)");
  if (!/[0-9]/.test(password || "")) errs.push("One digit (0-9)");
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password || "")) errs.push("One special character (!@#$…)");
  return errs;
}

/** 0..4 score for a UI meter. */
export function passwordStrengthScore(password) {
  return Math.max(0, 5 - passwordStrengthErrors(password).length);
}
